// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FrejaEidButton_reset-list_sd853{margin:0;padding:0;list-style:none;display:block}.FrejaEidButton_uppercase-sm_3Zlcb{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.FrejaEidButton_icon_3b_4O{display:block;width:112px;height:auto}", ""]);
// Exports
exports.locals = {
	"reset-list": "FrejaEidButton_reset-list_sd853",
	"uppercase-sm": "FrejaEidButton_uppercase-sm_3Zlcb",
	"icon": "FrejaEidButton_icon_3b_4O"
};
module.exports = exports;
